import IncidentsLayout from "../layouts/IncidentsLayout";

const Incidents = () => {
  return (
    <div className="p-8 bg-gray-100">
      <IncidentsLayout />
    </div>
  );
};

export default Incidents;
